import * as React from 'react'
import { Check, ChevronDown } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from '@/components/ui/command'
import { Button } from '@/components/ui/button'

const TIMEZONES: string[] = (() => {
  try { return (Intl as any).supportedValuesOf('timeZone') as string[] } catch { return ['UTC', 'Europe/Brussels', 'Europe/London', 'America/New_York'] }
})()

export default function TimezoneSelect({ value, onChange, readOnly }: { value: string, onChange: (tz: string) => void, readOnly?: boolean }) {
  const { t } = useTranslation()
  const [open, setOpen] = React.useState(false)
  const options = TIMEZONES.includes(value) ? TIMEZONES : [value, ...TIMEZONES]

  if (readOnly) return <span>{value}</span>

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger render={<Button variant='link' className='h-auto gap-1 p-0 text-sm font-normal text-foreground/80 hover:no-underline' />}>
        {value}
        <ChevronDown className='size-4 stroke-3' />
      </PopoverTrigger>
      <PopoverContent className='w-72 p-0' align='start'>
        <Command>
          <CommandInput placeholder={t('Scheduling::Search timezone')} className='text-base' />
          <CommandList>
            <CommandEmpty>{t('Scheduling::No timezone found')}</CommandEmpty>
            {options.map(tz => (
              <CommandItem key={tz} value={tz} onSelect={() => { onChange(tz); setOpen(false) }}>
                <Check className={tz === value ? 'size-4 opacity-100' : 'size-4 opacity-0'} />
                {tz}
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  )
}
